import React from "react";
import MasterTable from "../MasterTable/MasterTable";
import { Box, CircularProgress, Paper, Typography } from "@mui/material";

const DepartmentReport = ({ columns, data, loading }) => {
  return (
    <Paper elevation={2} sx={{ p: 2, height: "100%" }}>
      <Typography
        variant="h6"
        gutterBottom
        sx={{ fontFamily: "Inter, sans-serif" }}
      >
        Comprehensive Data
      </Typography>

      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100px",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <MasterTable columns={columns} data={data} pagination={true} />
      )}
    </Paper>
  );
};

export default DepartmentReport;
